import { render, staticRenderFns } from "./MyFavoritesEquipment.vue?vue&type=template&id=246b2932&scoped=true"
import script from "./MyFavoritesEquipment.vue?vue&type=script&lang=js"
export * from "./MyFavoritesEquipment.vue?vue&type=script&lang=js"
import style0 from "./MyFavoritesEquipment.vue?vue&type=style&index=0&id=246b2932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b2932",
  null
  
)

export default component.exports